import { api } from '@/lib/api/client'
import type {
  CreateOrganizationInput,
  Organization,
} from '@/features/organizations/types/organization'

/** `POST /organizations` creates an organization; the caller becomes its Organization Admin. */
export async function createOrganization(input: CreateOrganizationInput): Promise<Organization> {
  const { data } = await api.post<{ data: Organization }>('/organizations', {
    name: input.name,
    company_name: input.companyName,
    // Optional details; empty fields are left out rather than sent as "".
    email: input.email || undefined,
    street_address: input.streetAddress || undefined,
    city: input.city || undefined,
    zip_code: input.zipCode || undefined,
    country: input.country || undefined,
    vat_number: input.vatNumber || undefined,
  })

  return data.data
}
